<button [attr.aria-label]="'Charge actions'" [matMenuTriggerFor]="singleChargeActions"
        class="absolute-more-btn on-hover"
        mat-icon-button>
    <mat-icon class="add-blue">more_horiz</mat-icon>
</button>

<mat-menu #singleChargeActions="matMenu" yPosition="below">
    <button (click)="chargeDetails()" mat-menu-item>
        <a>Charge Details</a>
    </button>
    <button [attr.data-charge-id]="charge.id" [attr.aria-label]="'Edit charge'" (click)="editCharge()" *ngIf="(hasWriteAccess && (!charge.deletedAt)) || jwt.superUser"
            mat-menu-item>
        <a>Edit</a>
    </button>
    <button (click)="forgiveCharge()" *ngIf="hasWriteAccess && !charge.deletedAt && charge.balance > 0"
            mat-menu-item>
        <a>Forgive Remainder</a>
    </button>
    <button (click)="processCreditsForCharge(charge.id)" *ngIf="jwt.superUser && !charge.deletedAt && charge.balance > 0"
            mat-menu-item>
        <a>Pay With Credit
            <app-super-star></app-super-star>
        </a>
    </button>
    <button (click)="deleteCharge()" *ngIf="hasWriteAccess && !charge.deletedAt"
            mat-menu-item>
        <a>Delete Charge</a>
    </button>

    <button (click)="removeLateFees()" *ngIf="hasWriteAccess && ((charge.lateFee && charge.lateAfter) || (charge.lateFees && charge.lateFees.length > 0)) && !charge.paid && !charge.deletedAt"
            mat-menu-item>
        <a>Remove Late Fees</a>
    </button>
    <button (click)="removeEarlyDiscount()" *ngIf="hasWriteAccess && charge.earlyDiscount && charge.earlyBefore && !charge.paid && !charge.deletedAt"
            mat-menu-item>
        <a>Remove Early Discount</a>
    </button>
    <button (click)="recordPayment()" *ngIf="hasPaymentsWrite && !charge.paid && !charge.deletedAt"
            mat-menu-item>
        <a>Record Payment</a>
    </button>
    <button (click)="createPaymentPlan()" *ngIf="hasPaymentsWrite && !charge.paid && !charge.deletedAt"
            mat-menu-item>
        <a>Payment Plan</a>
    </button>
    <button (click)="emailInvoice()" *ngIf="hasWriteAccess && !charge.paid && !charge.deletedAt && (charge | chargeStatus) !== 'future'"
            mat-menu-item>
        <a>Email Invoice</a>
    </button>
    <button (click)="downloadInvoice()"
            mat-menu-item>
        <a>Download Invoice</a>
    </button>
    <button (click)="reinstateCharge()" *ngIf="hasWriteAccess && charge.deletedAt"
            mat-menu-item>
        <a>Reinstate Charge</a>
    </button>
    <button (click)="archiveCharge()" *ngIf="(jwt.admin || jwt.superUser) && charge.deletedAt"
            mat-menu-item>
        <a>Archive Charge</a>
    </button>
    <button (click)="showChargeAudit()" *ngIf="jwt.superUser"
            mat-menu-item>
        <a>History
            <app-super-star></app-super-star>
        </a>
    </button>
</mat-menu>

